import OpenAIApi from '@/api/openai'

const _state = {}
const getters = {}
const actions = {
  sendFeedbackOnDocumentQuizzes: async (_, payload) => {
    await OpenAIApi.sendFeedbackOnDocumentQuizzes(payload)
  },
  sendFeedbackOnSlidesGeneratorResult: async (_, payload) => {
    await OpenAIApi.sendFeedbackOnSlidesGeneratorResult(payload)
  },
}
const mutations = {}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
